import { useSelector } from 'react-redux';
import { isLegacyPaidPlan } from '@helpers/billing';
import LegacyPlanDrawer from './LegacyPlanDrawer';
import SubscribeDrawer from './SubscribeDrawer';

const BillingDrawer = () => {
    const account = useSelector(state => state.account?.account);

    return isLegacyPaidPlan(account) ? <LegacyPlanDrawer /> : <SubscribeDrawer />;
};

export default BillingDrawer;
